module.exports = __webpack_public_path__ + "img/alipayIcon.2ae75cc6.png";